import Route from "vue-routisan";
import vuex from "src/vuex";
import isAuthenticated from "../middlewares/isAuthenticated";
import isShipper from "@/http/routes/middlewares/isShipper";
import hasTrackingPermission from "@/http/routes/middlewares/hasPermission/hasTrackingPermission";

Route.group({}, () => {

  Route.group({prefix: 'truck_position', beforeEnter: [isAuthenticated,hasTrackingPermission]}, () => {
    Route.group({prefix: "shipper", beforeEnter: [isShipper]}, () => {
      Route.group({prefix: "tracking_solicitation"}, () => {

        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "src/resources/views/truckPosition/shipper/trackingSolicitation/TrackingSolicitationList")
        ).name("shipper.tracking")
          .options({
            meta: {
              layout: () => import(/* webpackChunkName: "shipper" */ "@/resources/views/truckPosition/shipper/layout/Layout.vue")
            }
          });

        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "src/resources/views/truckPosition/shipper/trackingSolicitation/TrackingSolicitationList")
        ).name("shipper.tracking_solicitation")
          .options({
            meta: {
              layout: () => import(/* webpackChunkName: "shipper" */ "@/resources/views/truckPosition/shipper/layout/Layout.vue")
            }
          });

        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "shipper" */ "src/resources/views/truckPosition/shipper/trackingSolicitation/TrackingSolicitationUpdate")
        ).name("shipper.tracking_solicitation_update")
          .options({
            meta: {
              layout: () => import(/* webpackChunkName: "shipper" */ "@/resources/views/truckPosition/shipper/layout/Layout.vue")
            }
          });

      });
    })
  });
});

export default Route.all();
